import { navigate, useMatch, useNavigate } from '@reach/router'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ColorFontNormal, ColorFontPrimary, ColorPrimary } from './ui/var'
import IconAccount from '../assets/menu/account.png'
import IconMessage from '../assets/menu/message.png'
import IconProfile from '../assets/menu/profile.png'
import IconMoney from '../assets/menu/money.svg'
import IconLogout from '../assets/menu/logout.png'
import { listingPayment } from '../services/payment'
import { Dropdown, Menu as AntMenu } from 'antd'
import { ROOT_PATH } from '../common/config'

interface IMenuItem {
  actived?: boolean
}

export const MenuItem = styled.div<IMenuItem>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ actived }) => (actived ? ColorFontPrimary : ColorFontNormal)};
  min-width: 100px;
  height: 100%;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  span {
    border-bottom: 2px solid transparent;
    border-color: ${({ actived }) => (actived ? ColorFontPrimary : 'transparent')};
  }

  &:hover {
    color: ${ColorPrimary};
    font-weight: 400;
    span {
      border-color: currentColor;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 20px 10px;
  }
`

const Row = styled.div`
  display: flex;
  height: 100%;
  align-items: center;

  div {
    margin: 0 10px;
  }
`

export const Menu: React.FC<{ className?: string }> = ({ className }) => {
  const match = useMatch(ROOT_PATH + '/dashboard/*')

  const [paymentList, setPaymentList] = useState<string[]>([])
  const n = useNavigate()

  useEffect(() => {
    const fetchPaymentList = async () => {
      const list = await listingPayment()
      setPaymentList(list)
    }
    fetchPaymentList()
  }, [])

  if (!match) {
    window.location.href = ROOT_PATH
    return null
  }

  const currentRouter = match['*']

  const PaymentMenu = (
    <AntMenu>
      {paymentList.length > 0 && <AntMenu.Item onClick={() => navigate(`${ROOT_PATH}/dashboard/payment/${paymentList[0]}`)}>Make a Payment</AntMenu.Item>}
      <AntMenu.Item onClick={() => navigate(ROOT_PATH + '/dashboard/payment/history')}>Payment Order History</AntMenu.Item>
    </AntMenu>
  )
  
  const ProfileMenu = (
    <AntMenu>
      <AntMenu.Item onClick={() => navigate(ROOT_PATH + '/dashboard/profile')}>My Profile</AntMenu.Item>
      <AntMenu.Item onClick={() => navigate(ROOT_PATH + '/dashboard/killSwitch')}>Kill Switch</AntMenu.Item>
    </AntMenu>
  )

  return (
    <Row className={className}>
      <MenuItem onClick={() => n(ROOT_PATH + '/dashboard/account')} actived={currentRouter === 'account'}>
        <img className="w-6 mr-2" src={IconAccount} alt="account" />
        <span>Account</span>
      </MenuItem>
      <Dropdown overlay={PaymentMenu}>
        <MenuItem actived={currentRouter === 'payment'}>
          <img className="w-6 mr-2" src={IconMoney} alt="account" />
          <span>Make a Payment</span>
        </MenuItem>
      </Dropdown>
	  <Dropdown overlay={ProfileMenu}>
	    <MenuItem actived={currentRouter === 'profile'}>
	      <img className="w-6 mr-2" src={IconProfile} alt="profile" />
	      <span>Profile</span>
	    </MenuItem>
	  </Dropdown>
      <MenuItem onClick={() => n(ROOT_PATH + '/dashboard/message')} actived={currentRouter === 'message'}>
        <img className="w-6 mr-2" src={IconMessage} alt="message" />
        <span>Message</span>
      </MenuItem>

      {/* <MenuItem onClick={() => n('./contact')} actived={currentRouter === 'contact'}>
        Contact
      </MenuItem> */}
    </Row>
  )
}

export const StyledMobileMenu = styled.div`
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.12);
`

export const MobileMenu: React.FC<{ className?: string; hideMenu?: Function; onLogout: Function }> = ({ className, hideMenu, onLogout }) => {
  const match = useMatch(ROOT_PATH + '/dashboard/*')

  const [paymentList, setPaymentList] = useState<string[]>([])
  // const n = useNavigate()

  useEffect(() => {
    const fetchPaymentList = async () => {
      const list = await listingPayment()
      setPaymentList(list)
    }
    fetchPaymentList()
  }, [])

  if (!match) {
    window.location.href = ROOT_PATH
    return null
  }

  const onMenuClick = (href: string) => {
    navigate(href)
    hideMenu && hideMenu()
  }

  return (
    <AntMenu className="flex flex-col w-full fixed z-50" style={{ top: '80px', boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.12)' }} mode="vertical">
      <AntMenu.Item className="flex items-center" onClick={() => onMenuClick(ROOT_PATH + '/dashboard/account')}>
        <img className="block w-6 h-auto mr-2" src={IconAccount} alt="account" />
        <span>Account</span>
      </AntMenu.Item>
      <AntMenu.Divider />
      <AntMenu.Item className="flex items-center" onClick={() => onMenuClick(ROOT_PATH + '/dashboard/profile')}>
        <img className="block w-6 h-auto mr-2" src={IconProfile} alt="profile" />
        <span>Profile</span>
      </AntMenu.Item>
      <AntMenu.Divider />
      <AntMenu.Item className="flex items-center" onClick={() => onMenuClick(ROOT_PATH + '/dashboard/message')}>
        <img className="w-6 mr-2" src={IconMessage} alt="message" />
        <span>Message</span>
      </AntMenu.Item>
      <AntMenu.Divider />
      <AntMenu.Item className="flex items-center" onClick={() => onMenuClick(ROOT_PATH + '/dashboard/payment/history')}>
        <img className="block w-6 h-auto mr-2" src={IconMoney} alt="account" />
        <span> Payment Order History</span>
      </AntMenu.Item>
      <AntMenu.Divider />
      {paymentList.length > 0 && (
        <>
          <AntMenu.Item className="flex items-center" onClick={() => onMenuClick(`${ROOT_PATH}/dashboard/payment/${paymentList[0]}`)}>
            <img className="block w-6 h-auto mr-2" src={IconMoney} alt="account" />
            <span>Make a Payment</span>
          </AntMenu.Item>
          <AntMenu.Divider />
        </>
      )}
      <AntMenu.Item className="flex items-center" onClick={() => onLogout()}>
        <img className="w-6 mr-2" src={IconLogout} alt="profile" />
        <span>Logout</span>
      </AntMenu.Item>
    </AntMenu>
  )
}
